import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, useMediaQuery, useTheme } from '@mui/material';
import type { TipoIdentificador } from '../../api';
import { GerenciadorPontosAcesso } from './gerenciador-pontos-acesso';
import { ROTULO_TIPO_IDENTIFICADOR } from './icone-modo';

/** "Mesa e Comanda" — lista curta em português, sem vírgula sobrando no fim. */
function rotuloDosTipos(tipos: TipoIdentificador[]): string {
  const nomes = tipos.map((t) => ROTULO_TIPO_IDENTIFICADOR[t] ?? t);
  if (nomes.length <= 1) return nomes[0] ?? '';
  return `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`;
}

interface DialogPontosAcessoProps {
  aberto: boolean;
  aoFechar: () => void;
  idConfig: number;
  /** Tipos desta aba — o modal só lista, cria e baixa QR destes. */
  tipos: TipoIdentificador[];
  /** Abre já no formulário de criação (atalho "Criar ponto de acesso"). */
  criarAoAbrir?: boolean;
}

/**
 * A tela "Acessos ao cardápio" dentro de um modal, recortada aos tipos da aba
 * que o abriu.
 *
 * Existe para o "Gerenciar pontos de acesso" não jogar quem está configurando
 * um modo para outra tela: lá ele veria a loja inteira (mesa, comanda, totem,
 * delivery...) para mexer em UM tipo, e perderia as alterações não salvas da
 * configuração no caminho. Aqui ele resolve os pontos daquele modo e volta
 * exatamente de onde saiu.
 *
 * A tela do menu lateral continua existindo — é a visão da loja inteira, com
 * todos os tipos juntos.
 */
export function DialogPontosAcesso({
  aberto,
  aoFechar,
  idConfig,
  tipos,
  criarAoAbrir = false,
}: DialogPontosAcessoProps): JSX.Element {
  const tema = useTheme();
  const noCelular = useMediaQuery(tema.breakpoints.down('sm'));

  return (
    <Dialog open={aberto} onClose={aoFechar} fullWidth maxWidth="md" fullScreen={noCelular}>
      <DialogTitle sx={{ pb: 1 }}>Pontos de acesso · {rotuloDosTipos(tipos)}</DialogTitle>
      <DialogContent dividers>
        <GerenciadorPontosAcesso
          idConfig={idConfig}
          tipos={tipos}
          criarAoMontar={criarAoAbrir}
          tamanhoPaginaInicial={10}
          cabecalho={(acoes) => (
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent="flex-end"
              sx={{ mb: 2, width: '100%' }}
            >
              {acoes}
            </Stack>
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={aoFechar}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
